"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePaddedImageDetails = void 0;
var React = __importStar(require("react"));
var toCropAreaState_1 = require("./toCropAreaState");
var addPaddingToImage_1 = require("../addPaddingToImage");
function usePaddedImageDetails(imageInfo, sourceImage) {
    return React.useMemo(function () {
        var _a;
        var filterRatio = (_a = imageInfo.filterInfo) === null || _a === void 0 ? void 0 : _a.ratio;
        var sourceImageInfo = imageInfo.srcImageInfo || imageInfo;
        var suggestedCrop = sourceImageInfo.suggestedCrop;
        /**
         * CropAreaState is always relative to the original source image. However, CROPRO does not
         * support a crop that is padded (negative x or y) so we have to generate a padded image
         * on the fly. We need to determine if the source image needed a padding crop so we can
         * correctly adjust and recreate the state for the edited image.
         */
        var shouldUsePaddedImage = suggestedCrop && (suggestedCrop.x < 0 || suggestedCrop.y < 0);
        var paddedImageInfo = null;
        var paddedImageSrc = null;
        var paddedCropAreaState = null;
        if (shouldUsePaddedImage) {
            paddedImageInfo = __assign(__assign({}, sourceImageInfo), { height: suggestedCrop.height, width: suggestedCrop.width });
            paddedImageSrc = (0, addPaddingToImage_1.addPaddingToImage)(sourceImage, suggestedCrop);
            var cropAreaState = (0, toCropAreaState_1.toCropAreaState)(imageInfo);
            if (cropAreaState && filterRatio === imageInfo.ratio) {
                var scale = getScaleOfSourceSizeToEditorSize(sourceImageInfo, cropAreaState);
                // Convert the previous state to be relative to the padded image instead of the source
                paddedCropAreaState = __assign(__assign({}, cropAreaState), { height: paddedImageInfo.height, width: paddedImageInfo.width, cropRect: {
                        height: scale * cropAreaState.cropRect.height,
                        width: scale * cropAreaState.cropRect.width,
                        // The CROPRO editor always adds a 20px offset to the coordinates, so we remove that
                        // before adjusting by the scale.
                        x: scale * (cropAreaState.cropRect.x - 20) - suggestedCrop.x + 20,
                        y: scale * (cropAreaState.cropRect.y - 20) - suggestedCrop.y + 20,
                    } });
            }
            else {
                // If there's no previous edit state or the state is at the wrong aspect ratio, we can
                // just create one with the crop at the full size of the padded image.
                paddedCropAreaState = {
                    flippedHorizontally: false,
                    flippedVertically: false,
                    rotationAngle: 0,
                    height: suggestedCrop.height,
                    width: suggestedCrop.width,
                    cropRect: {
                        height: suggestedCrop.height,
                        width: suggestedCrop.width,
                        // The CROPRO editor expects a 20px offset to the crop coordinates
                        x: 20,
                        y: 20,
                    },
                };
            }
        }
        function convertPaddedStateToSourceState(state) {
            if (!shouldUsePaddedImage) {
                return state;
            }
            var scale = getScaleOfSourceSizeToEditorSize(sourceImageInfo, state);
            // Convert the state to be relative to the source image instead of the padded image
            return __assign(__assign({}, state), { height: sourceImageInfo.height, width: sourceImageInfo.width, cropRect: {
                    height: scale * state.cropRect.height,
                    width: scale * state.cropRect.width,
                    // The CROPRO editor always adds a 20px offset to the coordinates, so we remove
                    // that before adjusting by the scale.
                    x: scale * (state.cropRect.x - 20) + suggestedCrop.x + 20,
                    y: scale * (state.cropRect.y - 20) + suggestedCrop.y + 20,
                } });
        }
        return {
            shouldUsePaddedImage: shouldUsePaddedImage,
            paddedImageInfo: paddedImageInfo,
            paddedImageSrc: paddedImageSrc,
            paddedCropAreaState: paddedCropAreaState,
            convertPaddedStateToSourceState: convertPaddedStateToSourceState,
        };
    }, [imageInfo]);
}
exports.usePaddedImageDetails = usePaddedImageDetails;
function getScaleOfSourceSizeToEditorSize(sourceImageInfo, cropAreaState) {
    var scaledByHeight = sourceImageInfo.height / cropAreaState.height;
    var scaledByWidth = sourceImageInfo.width / cropAreaState.width;
    var suggestedCrop = sourceImageInfo.suggestedCrop;
    if (suggestedCrop && suggestedCrop.x < 0) {
        // Padding was added to the width, so height can be used to compare the sizes.
        return scaledByHeight;
    }
    else if (suggestedCrop && suggestedCrop.y < 0) {
        // Padding was added to the height, so width can be used to compare the sizes.
        return scaledByWidth;
    }
    // There's no padding so the proportion should be the same by height or width. Just pick one.
    return scaledByHeight;
}
